module.exports = __webpack_public_path__ + "static/media/map-pin.3939dd6b.svg";